// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-d"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 19V5H15C15.5523 5 16 5.44772 16 6V18C16 18.5523 15.5523 19 15 19H8Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersDIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-d',
    ref,
    icon: element,
  },
));

LettersDIcon.displayName = 'LettersDIcon';

export default LettersDIcon;
